import { CircularProgress, TextField } from '@material-ui/core';
import { setBoExcluidoByIndex, setFiles, setFilesByIndex } from 'app/store/slices/forms';
import { SERVICES_CODES } from 'app/config/services';
import { Field } from 'formik';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DocumentField from '../DocumentField';
import GrowingTable from '../GrowingTable';
import { DOCUMENT_TYPES } from 'app/utils/constants';
import { STATUS_CODES } from 'app/config/status';
import { fixedDocumentName } from 'app/utils/forms/validators/file';

const OtherDocuments = props => {
  const dispatch = useDispatch();
  const {
    canEdit,
    disableEditFile,
    loadingDocuments,
    setLoadingDocuments,
    othersDocuments,
    setOthersDocuments,
    dePlaca,
    title = 'Outros',
    customDeleteDocuments,
  } = props;

  const documents = useSelector(state => state.forms.files);
  const service = useSelector(state => state.services.details);
  const request = useSelector(state => state.requests.details);
  const filesStore = useSelector(state => state.forms.files);

  const [uploading, setUpLoading] = useState(false);

  const handleChangeFile = useCallback(
    async (docParam, index) => {
      if (docParam.id) {
        let file = {};
        const found = _.find(filesStore, ['idFile', docParam.id]);
        if (found) {
          file = { ...found };
        }
        file = {
          ...file,
          idFile: docParam.id,
          fileName: docParam.name,
          cdTipoDocumento: DOCUMENT_TYPES.OTHERS,
          canEdit: canEdit,
        };
        file.boExcluido = docParam.boExcluido || false;
        file.boAlterado = docParam.boAlterado || false;
        if (docParam.idGdoc) file.idGdoc = docParam.idGdoc;
        await dispatch(setFilesByIndex({ data: file, index }));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, canEdit],
  );

  const handleDeleteFile = useCallback(
    async (idFile, index) => {
      await dispatch(setBoExcluidoByIndex({ index }));
    },
    [dispatch],
  );

  const [filesTableData, setFilesTableData] = useState({
    columns: [
      {
        title: 'Arquivo',
        field: 'fileName',
        align: 'left',
        showContent: (value, index) => {
          return (
            <>
              <Field
                {...props}
                value={value.fileName}
                required={true}
                name={value?.fileName ? value.fileName : `documento-adicional-${index}`}
                id={`${DOCUMENT_TYPES.OTHERS}-${index}`}
                preffix={value?.dePlaca}
                disabled={!value.canEdit}
                idGdoc={value?.idGdoc}
                idFile={value?.idFile}
                onChangeFile={doc => {
                  handleChangeFile(doc, index);
                  setUpLoading(false);
                }}
                onDeleteFile={idFile => handleDeleteFile(idFile, index)}
                uploading={uploading}
                setUpLoading={setUpLoading}
                fullWidth
                margin='dense'
                component={DocumentField}
              />
            </>
          );
        },
      },
      {
        title: 'Descrição',
        field: 'deDescricao',
        align: 'left',
        editComponent: props => (
          <TextField
            {...props}
            margin='dense'
            label=''
            fullWidth
            inputProps={{
              maxLength: 90,
            }}
            InputLabelProps={{
              shrink: true,
            }}
            error={props.value === ''}
            helperText={props.value === '' ? 'Campo obrigatório' : ''}
          />
        ),
      },
    ],
    data: documents,
  });

  useEffect(() => {
    const init = async () => {
      const tempFileData = _.cloneDeep(filesTableData);
      tempFileData.data = othersDocuments.filter(doc => !doc.boExcluido);
      setFilesTableData(tempFileData);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [othersDocuments]);

  const customAddDocuments = async index => {
    setLoadingDocuments(true);
    let tempDocuments = [...documents];

    let canEditDoc = canEdit;
    if (!canEditDoc && service.cdServico === SERVICES_CODES.EXCLUSAO_VEICULOS) {
      if (!request.situacao) {
        // new request
        canEditDoc = true;
      } else {
        canEditDoc =
          request.situacao?.boEdicaoPortalExterno ||
          request.cdSituacao === STATUS_CODES.EM_CONSTRUCAO;
      }
    }

    if (index === undefined) {
      const initObj = {
        canEdit: canEditDoc,
      };
      if (dePlaca) initObj.dePlaca = dePlaca;
      tempDocuments.push(initObj);
    } else {
      if (window.confirm('Deseja excluir este item?')) {
        if (customDeleteDocuments) {
          tempDocuments = await customDeleteDocuments({ documentsList: tempDocuments, index });
        } else {
          if (tempDocuments[index]?.idFile) {
            await dispatch(setBoExcluidoByIndex({ index }));
            tempDocuments.splice(index, 1);
          } else {
            tempDocuments.splice(index, 1);
          }
        }
      }
    }
    setOthersDocuments(tempDocuments);
    await dispatch(setFiles(tempDocuments));
    setLoadingDocuments(false);
  };

  const addFiles = async fileData => {
    const tempDocuments = [...documents];
    tempDocuments.push({});
    setOthersDocuments(tempDocuments);
    await dispatch(setFiles(tempDocuments));
  };

  const onChangeField = (e, index) => {
    const name = e.target.name;
    const value = e.target.value;
    const temp = _.cloneDeep(documents);
    if (temp[index]) {
      temp[index][name] = value;
      setOthersDocuments(temp);
    }
  };

  const onBlurField = async (e, index) => {
    const name = e.target.name;
    let value = e.target.value;

    if (name === 'deDescricao') {
      value = fixedDocumentName(value);
      const temp = _.cloneDeep(documents);
      if (temp[index]) {
        temp[index][name] = value;
        setOthersDocuments(temp);
      }
    }

    if (documents[index]) {
      const file = { ...documents[index] };
      file[name] = value;
      await dispatch(setFilesByIndex({ data: file, index }));
    }
  };

  return (
    <>
      {loadingDocuments && <CircularProgress size={16} />}
      {!loadingDocuments && (
        <GrowingTable
          title={title}
          tabledata={filesTableData}
          addtabledata={addFiles}
          handlechange={onChangeField}
          handleblur={onBlurField}
          customAddElement={customAddDocuments}
          loading={loadingDocuments}
          canEdit={!disableEditFile}
        />
      )}
    </>
  );
};

export default OtherDocuments;
